import type { FaireProductEntity } from "../../entity_types/product";

export const p_byktfbfcws: FaireProductEntity = {
  token: "p_byktfbfcws",
  type: "product",
  name: "Two-tone Texture Knit Baby Romper (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/7284a9b62b9d4cff0876f72541649bbdc4e4c36ce4f62351d1d4ce4b585bb5fd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4431b68df01e7eb33754b838b2662006a2b1acbacf4cf0d6f8580c3534b88e36.png",
    "https://cdn.faire.com/fastly/25ae56450e5090ce795848bbea0bc6832d59e37232329360f8947f427c2d1485.png",
    "https://cdn.faire.com/fastly/4d5921393ac9cdd31083c6e0e351d0ed4665b1f1dbca6e3a14bdc8c658f3fcf0.png",
  ],
  priceDollars: 24,
  description:
    "Timeless, soft, and naturally breathable, this premium organic cotton Two-tone Knit Baby Romper is thoughtfully crafted for lightweight everyday comfort.\n\nOur 100% organic cotton baby sweater is thoughtfully made as a truly special piece, blending timeless beauty, comfort, and sustainability. Designed for families who value thoughtfully made organic baby clothes, it reflects heirloom-quality craftsmanship and refined design.\n\nWhy It’s Special:\n\n• Heirloom-Quality Organic Cotton\nBreathable, 100% organic cotton with exceptional softness and a beautiful finish.\n\n• Safe, Non-Toxic & Gentle\nEco-friendly, chemical-free materials and gentle dyes for delicate skin.\n\n• Crafted to Last\nMeticulous detailing ensures lasting quality and comfort.\n\n• Designed in the USA, Responsibly Made\nDesigned in the USA and ethically produced in India, supporting sustainable practices.\n\n• Timeless Design\nWhimsical yet refined details for everyday moments and special occasions.\n\nPerfect for Gifting\nWith its heirloom-quality feel and timeless design, this organic cotton baby sweater makes a meaningful gift for baby showers, newborns, and first holidays.\n\nChoose Viverano Organics for heirloom-quality organic baby clothing—thoughtfully designed for little ones and the planet. Happy baby. Happy earth.",
  tags: [],
  msrpDollars: 48,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T19:56:50.117Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
